export function initCalculatorReveal() {
    const section = document.querySelector('[data-calculator-reveal]');
    if (!section) return;

    const heading = section.querySelector('.calculator-reveal__heading');
    if (!heading) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;

    const update = () => {
        frame = 0;
        const progress = Math.min(1, Math.max(0, 1 - section.getBoundingClientRect().top / window.innerHeight));
        section.style.setProperty('--calculator-heading-scale', reducedMotion.matches ? 1 : 0.8 + progress * 0.2);
    };
    const schedule = () => {
        if (!frame) frame = requestAnimationFrame(update);
    };
    const resizeObserver = new ResizeObserver(() => {
        section.style.setProperty('--calculator-heading-height', `${heading.offsetHeight}px`);
        schedule();
    });

    resizeObserver.observe(heading);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    reducedMotion.addEventListener('change', schedule);
    update();
}
